/* Generated by jms-model/scripts/generate.label.icons.ts — do not edit.
 * Source: jms-web icon-picker packs (icomoon + FA6 solid).
 */
export const LABEL_ICOMOON_ICON_NAMES = [
    'electrical-safety',
    'gas-safety',
    'smoke-safety',
] as const;

export const LABEL_FA_SOLID_ICON_NAMES = [
    'shield-cat',
    'lungs-virus',
    'land-mine-on',
    'suitcase-rolling',
    'person-hiking',
    'users-slash',
    'file-circle-minus',
    'road-circle-xmark',
    'right-left',
    'icons',
    'shuttle-space',
    'screwdriver',
    'computer',
    'arrow-up-short-wide',
    'square-plus',
    'heart-circle-xmark',
    'cat',
    'car',
    'hand-holding-droplet',
    'briefcase-medical',
    'person',
    'square',
    'baseball',
    'microphone-lines-slash',
    'cloud-sun',
    'kaaba',
    'square-h',
    'pump-soap',
    'seedling',
    'table',
    'face-grin-wink',
    'trowel-bricks',
    'baby',
    'cubes',
    'volume-low',
    'cloud-meatball',
    'magnifying-glass-arrow-right',
    'sheet-plastic',
    'arrow-up-from-ground-water',
    'door-closed',
    'torii-gate',
    'check-double',
    'earth-oceania',
    'building-columns',
    'toggle-off',
    'children',
    'earth-asia',
    'bell',
    'hand-scissors',
    'file-audio',
    'bridge-circle-exclamation',
    'earth-europe',
    'chevron-right',
    'vest-patches',
    'ban-smoking',
    'align-justify',
    'lemon',
    'person-walking-luggage',
    'bolt-lightning',
    'building-flag',
    'egg',
    'tape',
    'stamp',
    'baby-carriage',
    'plate-wheat',
    'bowl-food',
    'sliders',
    'comment-slash',
    'align-left',
    'mars-and-venus-burst',
    'person-chalkboard',
    'headphones',
    'hashtag',
    'ruler-horizontal',
    'lock',
    'video-slash',
    'person-arrow-down-to-line',
    'user-large-slash',
    'signature',
    'cube',
    'arrow-pointer',
    'map-location',
    'folder-closed',
    'drum-steelpan',
    'handshake',
    'thumbs-down',
    'font',
    'anchor',
    'person-skating',
    'circle-question',
    'feather',
    'clipboard-check',
    'user-slash',
    'industry',
    'delete-left',
    'shekel-sign',
    'gem',
    'gamepad',
    'hands-praying',
    'window-maximize',
    'computer-mouse',
    'head-side-cough-slash',
    'registered',
    'flag-usa',
    'wine-bottle',
    'ghost',
    'house-circle-xmark',
    'list-check',
    'otter',
    'circle-chevron-left',
    'plug-circle-bolt',
    'radio',
    'inbox',
    'file-video',
    'backward-fast',
    'smoking',
    'file-code',
    'truck',
    'face-sad-tear',
    'money-bills',
    'helicopter-symbol',
    'user-minus',
    'dove',
    'angles-right',
    'brain',
    'person-dress-burst',
    'group-arrows-rotate',
    'copyright',
    'mortar-pestle',
    'bowling-ball',
    'calculator',
    'candy-cane',
    'square-poll-vertical',
    'wine-glass',
    'cookie-bite',
    'tag',
    'hryvnia-sign',
    'truck-ramp-box',
    'arrow-down-wide-short',
    'calendar-day',
    'helmet-un',
    'mars-stroke',
    'less-than-equal',
    'anchor-circle-check',
    'money-check',
    'download',
    'virus-slash',
    'info',
    'headset',
    'location-dot',
    'burger',
    'folder-plus',
    'user-tie',
    'bell-concierge',
    'file-shield',
    'hat-cowboy',
    'not-equal',
    'book-open',
    'splotch',
    'comments-dollar',
    'cent-sign',
    'comments',
    'explosion',
    'fingerprint',
    'peace',
    'calendar-check',
    'shuffle',
    'tablets',
    'pen-ruler',
    'football',
    'masks-theater',
    'pen-clip',
    'tooth',
    'eye-dropper',
    'hands-holding',
    'mountain',
    'hat-wizard',
    'envelope',
    'helmet-safety',
    'person-skiing-nordic',
    'asterisk',
    'sailboat',
    'up-down',
    'hand-lizard',
    'person-breastfeeding',
    'cloud-arrow-up',
    'hard-drive',
    'spinner',
    'crosshairs',
    'glass-water-droplet',
    'users-between-lines',
    'braille',
    'head-side-virus',
    'face-smile-beam',
    'cake-candles',
    'cart-arrow-down',
    'code',
    'book-journal-whills',
    'circle-plus',
    'poo-storm',
    'sort-down',
    'landmark',
    'book-open-reader',
    'indent',
    'certificate',
    'square-caret-left',
    'face-flushed',
    'droplet-slash',
    'snowplow',
    'print',
    'pen',
    'fill-drip',
    'rupee-sign',
    'language',
    'envelope-open-text',
    'reply',
    'memory',
    'xmark',
    'face-grin-stars',
    'truck-front',
    'temperature-high',
    'tent-arrow-left-right',
    'arrow-down-up-lock',
    'tornado',
    'house-chimney-user',
    'chart-area',
    'star-half',
    'truck-arrow-right',
    'taxi',
    'grip-lines',
    'file-excel',
    'person-falling',
    'square-caret-up',
    'arrows-left-right-to-line',
    'ice-cream',
    'arrow-down-up-across-line',
    'face-grin-tongue',
    'plane-circle-check',
    'trademark',
    'hand-back-fist',
    'venus',
    'hot-tub-person',
    'parachute-box',
    'map-pin',
    'file-arrow-up',
    'repeat',
    'snowman',
    'mound',
    'forward',
    'circle-up',
    'school-circle-check',
    'satellite',
    'yin-yang',
    'cable-car',
    'person-biking',
    'microchip',
    'face-frown',
    'arrow-up-z-a',
    'school-circle-exclamation',
    'house-medical-circle-check',
    'trash',
    'temperature-arrow-up',
    'sack-xmark',
    'calendar-plus',
    'skull-crossbones',
    'car-on',
    'circle-arrow-right',
    'person-circle-question',
    'square-phone',
    'code-branch',
    'question',
    'vest',
    'star-and-crescent',
    'superscript',
    'scale-unbalanced-flip',
    'thermometer',
    'dungeon',
    'lungs',
    'recycle',
    'money-check-dollar',
    'ear-listen',
    'house-flood-water',
    'tractor',
    'door-open',
    'shield-virus',
    'user-plus',
    'tents',
    'money-bill',
    'tarp',
    'file-csv',
    'handshake-slash',
    'umbrella-beach',
    'car-battery',
    'face-laugh',
    'circle-pause',
    'vihara',
    'hand-pointer',
    'people-pulling',
    'paw',
    'user-lock',
    'gas-pump',
    'hands-holding-circle',
    'earth-americas',
    'arrow-down-a-z',
    'chart-line',
    'rotate-right',
    'fill',
    'file-word',
    'film',
    'lines-leaning',
    'angles-left',
    'tachograph-digital',
    'person-rifle',
    'podcast',
    'receipt',
    'table-cells',
    'user-tag',
    'shield',
    'file-circle-question',
    'coins',
    'file',
    'bridge',
    'comment-sms',
    'plug',
    'hand-point-down',
    'server',
    'lock-open',
    'scale-unbalanced',
    'arrows-rotate',
    'warehouse',
    'circle-arrow-left',
    'sort',
    'house-chimney-window',
    'plus',
    'heart-circle-exclamation',
    'anchor-lock',
    'hands-asl-interpreting',
    'horse',
    'hamsa',
    'meteor',
    'virus',
    'dice-d6',
    'strikethrough',
    'smog',
    'calendar-xmark',
    'eraser',
    'person-booth',
    'star-of-life',
    'manat-sign',
    'republican',
    'clock',
    'hill-rockslide',
    'house-signal',
    'truck-droplet',
    'lightbulb',
    'flask-vial',
    'book-bookmark',
    'right-from-bracket',
    'arrows-turn-right',
    'diagram-successor',
    'bars',
    'phone',
    'users-rays',
    'clipboard-question',
    'building-lock',
    'code-merge',
    'person-arrow-up-from-line',
    'eject',
    'vr-cardboard',
    'sd-card',
    'circle-nodes',
    'box',
    'toilet-paper',
    'plane-circle-exclamation',
    'draw-polygon',
    'filter-circle-xmark',
    'arrow-right-arrow-left',
    'road-spikes',
    'square-nfi',
    'mars',
    'person-harassing',
    'eye-low-vision',
    'user-xmark',
    'volcano',
    'angles-up',
    'file-invoice',
    'scale-balanced',
    'face-kiss',
    'person-digging',
    'train-subway',
    'user-graduate',
    'person-skiing',
    'up-down-left-right',
    'bath',
    'user-secret',
    'road-lock',
    'camera',
    'beer-mug-empty',
    'mask',
    'faucet-drip',
    'chalkboard-user',
    'face-sad-cry',
    'jedi',
    'spray-can-sparkles',
    'qrcode',
    'people-carry-box',
    'volume-off',
    'user-ninja',
    'viruses',
    'arrows-left-right',
    'handshake-simple-slash',
    'fish-fins',
    'worm',
    'circle-down',
    'fire-extinguisher',
    'house-medical-circle-exclamation',
    'hat-cowboy-side',
    'gifts',
    'arrow-up-from-bracket',
    'file-circle-xmark',
    'people-group',
    'person-walking-with-cane',
    'marker',
    'sack-dollar',
    'kip-sign',
    'pen-nib',
    'circle-xmark',
    'road',
    'circle-info',
    'magnifying-glass',
    'pencil',
    'oil-can',
    'wifi',
    'heart-pulse',
    'comment-medical',
    'italic',
    'handshake-simple',
    'stroopwafel',
    'id-badge',
    'greater-than-equal',
    'terminal',
    'face-rolling-eyes',
    'pause',
    'truck-medical',
    'closed-captioning',
    'plant-wilt',
    'house-circle-check',
    'arrow-trend-up',
    'fire',
    'star-of-david',
    'map',
    'file-contract',
    'equals',
    'gavel',
    'star',
    'arrow-right-to-bracket',
    'peso-sign',
    'sleigh',
    'arrows-up-down',
    'upload',
    'spray-can',
    'shield-dog',
    'pepper-hot',
    'square-arrow-up-right',
    'bridge-circle-xmark',
    'chess-knight',
    'book-medical',
    'clone',
    'fish',
    'dog',
    'hands-holding-child',
    'ethernet',
    'dice-three',
    'ellipsis-vertical',
    'user-shield',
    'id-card',
    'building-shield',
    'suitcase-medical',
    'bridge-circle-check',
    'tent-arrow-turn-left',
    'code-commit',
    'thumbs-up',
    'shirt',
    'house-lock',
    'pen-fancy',
    'user-doctor',
    'envelope-circle-check',
    'spa',
    'users',
    'tenge-sign',
    'person-shelter',
    'check',
    'hand-point-up',
    'file-lines',
    'venus-double',
    'broom-ball',
    'sink',
    'hands-bubbles',
    'swatchbook',
    'photo-film',
    'mask-face',
    'square-caret-right',
    'sitemap',
    'code-fork',
    'plug-circle-minus',
    'vial-virus',
    'arrows-down-to-people',
    'comment-dollar',
    'pills',
    'sign-hanging',
    'hanukiah',
    'arrow-trend-down',
    'mug-saucer',
    'place-of-worship',
    'child',
    'trowel',
    'circle-chevron-up',
    'baseball-bat-ball',
    'building-wheat',
    'prescription',
    'bicycle',
    'angle-right',
    'face-grin-wide',
    'stethoscope',
    'tarp-droplet',
    'user-group',
    'up-long',
    'bottle-droplet',
    'infinity',
    'i-cursor',
    'record-vinyl',
    'hospital-user',
    'chevron-left',
    'circle-check',
    'bell-slash',
    'maximize',
    'menorah',
    'snowflake',
    'handshake-angle',
    'champagne-glasses',
    'file-waveform',
    'circle-h',
    'building',
    'radiation',
    'user-check',
    'bookmark',
    'user-astronaut',
    'hill-avalanche',
    'faucet',
    'arrow-down-short-wide',
    'hand-holding-heart',
    'landmark-dome',
    'arrow-down-9-1',
    'plane-departure',
    'plug-circle-exclamation',
    'camera-retro',
    'cart-flatbed-suitcase',
    'life-ring',
    'mosquito-net',
    'grip-lines-vertical',
    'toolbox',
    'hourglass-end',
    'audio-description',
    'wind',
    'stop',
    'location-pin',
    'chart-pie',
    'gopuram',
    'microphone-lines',
    'clipboard',
    'lari-sign',
    'money-bill-wave',
    'user-pen',
    'arrow-down',
    'link',
    'toilet-paper-slash',
    'phone-volume',
    'cloud-moon-rain',
    'music',
    'temperature-three-quarters',
    'angle-left',
    'person-drowning',
    'indian-rupee-sign',
    'wheelchair-move',
    'clover',
    'pen-to-square',
    'futbol',
    'face-laugh-beam',
    'square-minus',
    'arrow-turn-up',
    'poop',
    'users-rectangle',
    'temperature-quarter',
    'van-shuttle',
    'building-un',
    'dice-two',
    'images',
    'bus-simple',
    'circle-user',
    'turn-up',
    'video',
    'quote-right',
    'person-rays',
    'bridge-lock',
    'wheelchair',
    'ellipsis',
    'arrow-rotate-right',
    'text-width',
    'arrows-to-eye',
    'volleyball',
    'folder-open',
    'face-laugh-squint',
    'virus-covid-slash',
    'stopwatch-20',
    'blender-phone',
    'hands-bound',
    'house-medical',
    'square-rss',
    'mars-and-venus',
    'cheese',
    'newspaper',
    'street-view',
    'laptop',
    'key',
    'hospital',
    'anchor-circle-xmark',
    'cloud',
    'chess-rook',
    'staff-snake',
    'whiskey-glass',
    'drumstick-bite',
    'person-circle-plus',
    'shop-lock',
    'prescription-bottle-medical',
    'face-grin-tongue-wink',
    'house-crack',
    'sun',
    'bullhorn',
    'colon-sign',
    'vector-square',
    'hand-spock',
    'fire-burner',
    'leaf',
    'circle',
    'person-praying',
    'truck-field',
    'rupiah-sign',
    'headphones-simple',
    'weight-scale',
    'up-right-from-square',
    'person-walking',
    'caret-up',
    'code-compare',
    'hand-fist',
    'circle-radiation',
    'person-snowboarding',
    'stapler',
    'shoe-prints',
    'sun-plant-wilt',
    'file-powerpoint',
    'flag',
    'water',
    'crutch',
    'chalkboard',
    'neuter',
    'car-tunnel',
    'arrow-up-a-z',
    'copy',
    'compass-drafting',
    'square-person-confined',
    'box-open',
    'ruble-sign',
    'dice-four',
    'dumbbell',
    'spell-check',
    'chevron-up',
    'network-wired',
    'subscript',
    'truck-monster',
    'at',
    'hands',
    'house-user',
    'car-rear',
    'frog',
    'cubes-stacked',
    'bore-hole',
    'circle-chevron-right',
    'blog',
    'code-pull-request',
    'weight-hanging',
    'cloud-showers-heavy',
    'bus',
    'bug',
    'drum',
    'message',
    'passport',
    'person-walking-arrow-loop-left',
    'file-zipper',
    'paragraph',
    'person-circle-minus',
    'bezier-curve',
    'socks',
    'file-circle-check',
    'people-roof',
    'puzzle-piece',
    'mill-sign',
    'phone-slash',
    'share-from-square',
    'database',
    'bed-pulse',
    'temperature-low',
    'xmarks-lines',
    'chair',
    'align-center',
    'plane-circle-xmark',
    'battery-full',
    'trash-can-arrow-up',
    'arrow-up-right-from-square',
    'face-dizzy',
    'forward-fast',
    'circle-chevron-down',
    'person-military-rifle',
    'cart-shopping',
    'monument',
    'chess-queen',
    'magnifying-glass-location',
    'arrow-up-right-dots',
    'arrow-right-long',
    'eye-slash',
    'house',
    'panorama',
    'wrench',
    'user-clock',
    'baht-sign',
    'capsules',
    'scroll-torah',
    'grip-vertical',
    'triangle-exclamation',
    'prescription-bottle',
    'clipboard-user',
    'motorcycle',
    'square-phone-flip',
    'face-surprise',
    'golf-ball-tee',
    'mitten',
    'pump-medical',
    'share',
    'floppy-disk',
    'dolly',
    'glasses',
    'building-circle-arrow-right',
    'suitcase',
    'retweet',
    'shapes',
    'bitcoin-sign',
    'chart-gantt',
    'teeth-open',
    'universal-access',
    'map-location-dot',
    'plug-circle-plus',
    'pager',
    'arrows-spin',
    'car-side',
    'list-ol',
    'bandage',
    'money-bill-transfer',
    'ban',
    'train-tram',
    'face-grin-hearts',
    'guitar',
    'mattress-pillow',
    'square-poll-horizontal',
    'scissors',
    'people-arrows',
    'compact-disc',
    'tv',
    'medal',
    'arrow-right-from-bracket',
    'heading',
    'hand-holding-medical',
    'gift',
    'laptop-code',
    'money-bill-1',
    'calendar-minus',
    'rectangle-ad',
    'hourglass',
    'tablet',
    'wand-sparkles',
    'users-viewfinder',
    'truck-field-un',
    'house-flag',
    'arrows-down-to-line',
    'carrot',
    'apple-whole',
    'envelope-open',
    'brush',
    'gauge-simple-high',
    'person-dress',
    'person-burst',
    'gauge-simple',
    'object-ungroup',
    'circle-arrow-down',
    'toilets-portable',
    'money-bill-wheat',
    'turkish-lira-sign',
    'face-grin-beam-sweat',
    'diagram-project',
    'cloud-showers-water',
    'cannabis',
    'pallet',
    'volume-high',
    'jet-fighter',
    'campground',
    'stopwatch',
    'handcuffs',
    'shield-heart',
    'bug-slash',
    'droplet',
    'virus-covid',
    'face-smile',
    'crop-simple',
    'chess-board',
    'face-kiss-beam',
    'hand',
    'battery-empty',
    'dumpster-fire',
    'arrows-to-dot',
    'store-slash',
    'face-grin-squint-tears',
    'fire-flame-curved',
    'church',
    'helicopter',
    'face-kiss-wink-heart',
    'laptop-file',
    'chess',
    'trash-arrow-up',
    'trophy',
    'house-chimney',
    'compress',
    'notdef',
    'bread-slice',
    'shower',
    'minimize',
    'toilet',
    'temperature-half',
    'bugs',
    'diamond',
    'sterling-sign',
    'person-through-window',
    'calendar-days',
    'face-meh-blank',
    'bowl-rice',
    'school-circle-xmark',
    'person-half-dress',
    'plane-lock',
    'list',
    'square-parking',
    'square-caret-down',
    'paperclip',
    'road-circle-exclamation',
    'circle-play',
    'building-user',
    'battery-quarter',
    'house-chimney-medical',
    'mercury',
    'comment-dots',
    'mosque',
    'notes-medical',
    'charging-station',
    'archway',
    'face-grimace',
    'om',
    'flask',
    'school',
    'head-side-mask',
    'rotate-left',
    'file-prescription',
    'book-skull',
    'ranking-star',
    'square-full',
    'couch',
    'keyboard',
    'litecoin-sign',
    'house-medical-flag',
    'expand',
    'paste',
    'table-tennis-paddle-ball',
    'tablet-button',
    'basketball',
    'wallet',
    'person-running',
    'window-minimize',
    'book-atlas',
    'stairs',
    'unlock',
    'arrow-down-1-9',
    'tent-arrows-down',
    'face-grin',
    'arrow-down-long',
    'heart',
    'dollar-sign',
    'khanda',
    'dice-five',
    'diamond-turn-right',
    'hammer',
    'check-to-slot',
    'locust',
    'umbrella',
    'genderless',
    'kit-medical',
    'face-smile-wink',
    'unlock-keyhole',
    'arrow-up-9-1',
    'square-pen',
    'square-envelope',
    'florin-sign',
    'arrow-up-long',
    'people-robbery',
    'location-crosshairs',
    'walkie-talkie',
    'dna',
    'file-image',
    'diagram-predecessor',
    'circle-dollar-to-slot',
    'martini-glass',
    'person-pregnant',
    'vial',
    'people-line',
    'euro-sign',
    'arrow-right-to-city',
    'square-share-nodes',
    'envelopes-bulk',
    'window-restore',
    'share-nodes',
    'mobile-screen-button',
    'ring',
    'plus-minus',
    'toggle-on',
    'guarani-sign',
    'building-circle-xmark',
    'plane-up',
    'circle-dot',
    'filter-circle-dollar',
    'address-card',
    'hotdog',
    'hourglass-start',
    'pizza-slice',
    'tablet-screen-button',
    'face-tired',
    'cross',
    'house-laptop',
    'location-pin-lock',
    'user-injured',
    'truck-plane',
    'building-circle-check',
    'graduation-cap',
    'atom',
    'biohazard',
    'spoon',
    'broom',
    'vial-circle-check',
    'hurricane',
    'file-export',
    'user-gear',
    'paper-plane',
    'tower-broadcast',
    'money-bill-trend-up',
    'mobile-screen',
    'basket-shopping',
    'arrow-right',
    'person-walking-arrow-right',
    'flag-checkered',
    'border-none',
    'city',
    'chess-king',
    'backward',
    'chart-column',
    'caret-left',
    'divide',
    'house-fire',
    'mars-stroke-right',
    'ruler-combined',
    'heart-circle-bolt',
    'greater-than',
    'cookie',
    'face-grin-beam',
    'fire-flame-simple',
    'person-swimming',
    'chart-bar',
    'satellite-dish',
    'head-side-cough',
    'spaghetti-monster-flying',
    'jar-wheat',
    'skull',
    'down-long',
    'utensils',
    'child-reaching',
    'comment',
    'gear',
    'bacteria',
    'mountain-city',
    'heart-crack',
    'truck-pickup',
    'id-card-clip',
    'file-medical',
    'spider',
    'right-to-bracket',
    'signs-post',
    'naira-sign',
    'school-flag',
    'briefcase',
    'circle-half-stroke',
    'heart-circle-minus',
    'bed',
    'restroom',
    'wheat-awn-circle-exclamation',
    'palette',
    'user-large',
    'circle-right',
    'ribbon',
    'hockey-puck',
    'blender',
    'arrow-up',
    'heart-circle-check',
    'user-nurse',
    'arrows-to-circle',
    'compass',
    'gauge',
    'face-meh',
    'cart-plus',
    'barcode',
    'bone',
    'rotate',
    'reply-all',
    'link-slash',
    'magnifying-glass-dollar',
    'jug-detergent',
    'users-gear',
    'business-time',
    'bag-shopping',
    'crown',
    'bong',
    'angles-down',
    'elevator',
    'dice-six',
    'kitchen-set',
    'brazilian-real-sign',
    'turn-down',
    'arrow-rotate-left',
    'caret-down',
    'feather-pointed',
    'mountain-sun',
    'circle-notch',
    'power-off',
    'icicles',
    'wave-square',
    'arrows-turn-to-dots',
    'arrow-up-from-water-pump',
    'slash',
    'magnifying-glass-chart',
    'rectangle-list',
    'wine-glass-empty',
    'less-than',
    'book',
    'magnifying-glass-minus',
    'person-military-to-person',
    'cloud-bolt',
    'bacon',
    'arrow-up-wide-short',
    'square-check',
    'chess-pawn',
    'moon',
    'jar',
    'mobile-button',
    'file-invoice-dollar',
    'shop',
    'house-tsunami',
    'house-chimney-crack',
    'phone-flip',
    'file-pdf',
    'traffic-light',
    'hand-dots',
    'teeth',
    'image',
    'location-arrow',
    'outdent',
    'holly-berry',
    'temperature-arrow-down',
    'angle-up',
    'microscope',
    'voicemail',
    'file-signature',
    'table-cells-large',
    'align-right',
    'venus-mars',
    'temperature-full',
    'mobile',
    'font-awesome',
    'play',
    'tty',
    'signal',
    'address-book',
    'bottle-water',
    'hand-point-left',
    'book-bible',
    'person-cane',
    'ticket-simple',
    'transgender',
    'folder-minus',
    'plug-circle-check',
    'truck-fast',
    'caravan',
    'ship',
    'boxes-stacked',
    'person-walking-dashed-line-arrow-right',
    'book-tanakh',
    'glass-water',
    'ankh',
    'face-frown-open',
    'arrow-left',
    'up-right-and-down-left-from-center',
    'folder',
    'vault',
    'mars-double',
    'house-medical-circle-xmark',
    'circle-arrow-up',
    'scroll',
    'synagogue',
    'joint',
    'forward-step',
    'truck-moving',
    'volume-xmark',
    'gauge-high',
    'file-pen',
    'trailer',
    'hand-peace',
    'hands-clapping',
    'gun',
    'martini-glass-empty',
    'heart-circle-plus',
    'plane-arrival',
    'martini-glass-citrus',
    'vials',
    'caret-right',
    'rainbow',
    'kiwi-bird',
    'ferry',
    'robot',
    'gears',
    'bold',
    'train',
    'border-all',
    'cow',
    'person-dots-from-line',
    'dice-d20',
    'paint-roller',
    'crop',
    'percent',
    'book-quran',
    'bars-staggered',
    'crow',
    'square-up-right',
    'minus',
    'bolt',
    'shop-slash',
    'mask-ventilator',
    'exclamation',
    'star-half-stroke',
    'bomb',
    'folder-tree',
    'sim-card',
    'route',
    'road-barrier',
    'wand-magic',
    'syringe',
    'burst',
    'tent-arrow-down-to-line',
    'hand-holding-dollar',
    'plane',
    'horse-head',
    'plane-slash',
    'tower-observation',
    'arrow-down-z-a',
    'oil-well',
    'left-right',
    'person-falling-burst',
    'clapperboard',
    'calendar',
    'trash-can',
    'hand-holding-hand',
    'laptop-medical',
    'a',
    'clipboard-list',
    'b',
    'franc-sign',
    'globe',
    'toilet-portable',
    'rectangle-xmark',
    'bars-progress',
    'section',
    'file-arrow-down',
    'i',
    'filter',
    'j',
    'user',
    'g',
    'h',
    'e',
    'thumbtack',
    'cedi-sign',
    'f',
    'c',
    'd',
    'diagram-next',
    '1',
    'backward-step',
    'austral-sign',
    '2',
    'paintbrush',
    '0',
    'cloud-rain',
    'tree-city',
    'mars-stroke-up',
    'building-circle-exclamation',
    '9',
    'road-bridge',
    '7',
    '8',
    '5',
    '6',
    '3',
    'landmark-flag',
    '4',
    'cruzeiro-sign',
    'chess-bishop',
    'face-angry',
    'shield-halved',
    'bangladeshi-taka-sign',
    'temperature-empty',
    'house-circle-exclamation',
    'person-circle-xmark',
    'shrimp',
    'fax',
    'person-circle-exclamation',
    'store',
    'tent',
    'face-grin-squint',
    'wheat-awn',
    'hand-point-right',
    'magnifying-glass-plus',
    'arrow-up-1-9',
    'fan',
    'anchor-circle-exclamation',
    'cart-flatbed',
    'mosquito',
    'battery-three-quarters',
    'microphone',
    'face-grin-tears',
    'face-grin-tongue-squint',
    'jet-fighter-up',
    'table-list',
    'person-military-pointing',
    'circle-exclamation',
    'tags',
    'clock-rotate-left',
    'ticket',
    'calendar-week',
    'sort-up',
    'hand-holding',
    'box-tissue',
    'magnet',
    'earth-africa',
    'dong-sign',
    'arrows-up-to-line',
    'display',
    'microphone-slash',
    'arrows-split-up-and-left',
    'square-virus',
    'chart-simple',
    'hourglass-half',
    'file-import',
    'ruler-vertical',
    'x-ray',
    'table-columns',
    'boxes-packing',
    'face-laugh-wink',
    'chevron-down',
    'file-circle-exclamation',
    'disease',
    'quote-left',
    'wand-magic-sparkles',
    'users-line',
    'cash-register',
    'child-dress',
    'grip',
    'bacterium',
    'dice-one',
    'school-lock',
    'bucket',
    'money-bill-1-wave',
    'object-group',
    'rss',
    'camera-rotate',
    'poo',
    'plug-circle-xmark',
    'ear-deaf',
    'arrow-left-long',
    'cloud-sun-rain',
    'ruler',
    'arrows-up-down-left-right',
    'hand-sparkles',
    'igloo',
    'democrat',
    'layer-group',
    'box-archive',
    'battery-half',
    'circle-left',
    'award',
    'dragon',
    'cloud-moon',
    'text-height',
    'child-combatant',
    'mug-hot',
    'rocket',
    'eye',
    'right-long',
    'down-left-and-up-right-to-center',
    'bullseye',
    'dumpster',
    'circle-stop',
    'bahai',
    'water-ladder',
    'file-circle-plus',
    'left-long',
    'binoculars',
    'highlighter',
    'timeline',
    'cloud-arrow-down',
    'lira-sign',
    'hotel',
    'mobile-retro',
    'won-sign',
    'soap',
    'piggy-bank',
    'bridge-water',
    'credit-card',
    'yen-sign',
    'q',
    'r',
    'o',
    'hand-middle-finger',
    'p',
    'rug',
    'peseta-sign',
    'm',
    'n',
    'k',
    'l',
    'tree',
    'y',
    'road-circle-check',
    'z',
    'w',
    'house-flood-water-circle-arrow-right',
    'circle-minus',
    'x',
    'square-xmark',
    'u',
    'image-portrait',
    'v',
    'list-ul',
    's',
    't',
    'arrow-turn-down',
    'angle-down',
    'building-ngo',
    'screwdriver-wrench',
    'person-circle-check',
    'square-root-variable',
    'underline',
    'tower-cell',
    'dice',
    'dharmachakra',
    'note-sticky',
    'car-burst',
    'solar-panel',
    'border-top-left',
    'hippo',
    'desktop',
    'text-slash',
] as const;

export const LABEL_ICON_NAMES = [
    ...LABEL_ICOMOON_ICON_NAMES,
    ...LABEL_FA_SOLID_ICON_NAMES,
] as const;

export type LabelIcomoonIconName = typeof LABEL_ICOMOON_ICON_NAMES[number];
export type LabelFaSolidIconName = typeof LABEL_FA_SOLID_ICON_NAMES[number];
export type LabelIconName = typeof LABEL_ICON_NAMES[number];
